<template>
  <div>
    <uni-popup ref="cPrescrip" type="bottom" :mask-click="true" @maskClick="close(true)">
      <uni-card title="处方" :is-full="true">
        <div class="gridClass">
          <uni-list>
            <uni-list-item>
              <template v-slot:title>
                <div class="patientName">
                  <span>{{ recordItem.patientName }}</span>
                  <span class="sex">
                    {{ getKeyValueText('sex_code', recordItem.patientSex) }}
                  </span>
                  <span class="age">
                    {{ birthToAge(recordItem.patientBirth) || recordItem.patientAge }}
                  </span>
                </div>
              </template>
              <template v-slot:note>
                <div class="preType">
                  <span>
                    {{ getKeyValueText('prescrip_type', prescripType) + '处方' }}
                  </span>
                </div>
              </template>
              <template v-slot:footer>
                <div class="serviceType">
                  <!-- ' ' 中间的空格不要去掉 就是这么写的 -->
                  <span class="self">
                    {{ getKeyValueText('patient_fee_type', recordItem.patientFeeType) || ' ' }}
                  </span>
                </div>
              </template>
            </uni-list-item>
          </uni-list>
          <div class="grid_wrap">
            <div class="prescrip_class">
              <ms-select-dicNew
                :code="'prescrip_class'"
                :title="'处方类型'"
                :right-text="prescripClass"
                :uniListTop="true"
                @changeDicValue="changePrescripClass"
              ></ms-select-dicNew>
            </div>
            <div class="row_wrap align">
              <span class="title valid_day">药房：</span>
              <radio-group :value="pharmacy" style="display: flex" @change="changePharmacy">
                <label
                  v-for="(item, i) in getKeyValue('pharmacy_identification')"
                  :key="i"
                  style="display: flex; align-items: center"
                >
                  <radio
                    color="#0089FF"
                    class="radio"
                    :value="item.code"
                    :checked="item.code == pharmacy"
                  />
                  <span class="r_text">{{ item.value }}</span>
                </label>
              </radio-group>
            </div>
            <div class="row_wrap align">
              <span class="title valid_day">效期：</span>

              <radio-group :value="validDays" style="display: flex" @change="checkOne">
                <label
                  v-for="(item, i) in getKeyValue('prescrip_valid_days')"
                  :key="i"
                  style="display: flex; align-items: center"
                >
                  <radio
                    color="#0089FF"
                    class="radio"
                    :value="item.code"
                    :checked="item.code == validDays"
                  />
                  <span class="r_text">{{ item.value }}天有效</span>
                </label>
              </radio-group>
            </div>
            <div class="row_wrap" style="align-items: flex-start; padding-bottom: 0">
              <!-- <div class="diagnosis"> -->
              <span class="diagnosis">诊断：</span>
              <!-- </div> -->
              <div v-if="symptomName" class="diagnosis_content">
                <div v-for="(item, i) in sysList" :key="i" class="diagnose_wrap">
                  <span :class="item.symptomType === '3' ? 'meng_text' : 'symptom_text'">
                    {{ item.symptomName || '' }}
                  </span>
                </div>
              </div>
            </div>
            <!-- 药品信息 -->
            <div class="row_wrap align" @click="addDrug">
              <span class="title">
                {{ prescripType === '7' ? '选择一人一方：' : '药品：' }}
              </span>
              <!-- 添加药品 -->
              <img class="add_img" src="@funcPuzzle/mini_doctor/add.png" />
              <!-- 添加药品 end-->
            </div>
            <ms-drug-show
              :drug-list="drugList"
              :prescrip-type="prescripType"
              :one-prescription-for-each-person="msZheng"
              :templateType="templateType"
              :ifUpdate="true"
              @editDrug="editDrug"
            />
            <!-- 药品信息 end-->
            <div v-if="prescripType === '3' || prescripType === '5' || prescripType === '6'">
              <div class="input_wrap">
                <span class="input_title">服药剂数：</span>
                <div class="input_row">
                  <input
                    v-model="form.doesNumber"
                    type="number"
                    placeholder="请输入"
                    placeholder-style="color:#CECECE;font-size:.597333rem"
                    placeholder-class="input-placeholder"
                    class="input_con"
                  />
                  <span class="unit">剂</span>
                </div>
              </div>
              <div class="card_wrap">
                <div class="fst_row">
                  <span class="label">处方用法</span>
                  <span class="text" @click="updateUsage">编辑</span>
                </div>
                <uni-list-item :border="false" :clickable="true">
                  <template v-slot:header>
                    <!-- 宁城中心医院 -->
                    <div
                      v-if="['28770'].includes(hospitalID)"
                      style="width: 100%; font-family: PingFangSC-Regular, PingFang SC !important"
                    >
                      <div class="row">
                        <span class="label">药品用法：</span>
                        <span class="text">
                          {{ getKeyValueText('chinese_drug_usage', form.chineseDrugUsage) }}
                        </span>
                      </div>
                      <div class="row">
                        <span class="label">包装量：</span>
                        <span class="text">{{ form.packageNumber }}</span>
                      </div>
                      <div class="row">
                        <span class="label">频率：</span>
                        <span class="text">
                          {{
                            getKeyValueText(
                              'chinese_drug_frequence_his',
                              form.herbFrequence || ''
                            ) || ''
                          }}
                        </span>
                      </div>
                      <div class="row">
                        <span class="label">每剂</span>
                        <span class="text">
                          {{ form.herbPerDoseTimes ? form.herbPerDoseTimes + '次' : '' }}
                        </span>
                      </div>
                    </div>
                    <!-- 其他医院 -->
                    <div
                      v-else
                      style="width: 100%; font-family: PingFangSC-Regular, PingFang SC !important"
                    >
                      <div class="row">
                        <span class="label">用药次数：</span>
                        <span class="text">{{ form.times }}</span>
                      </div>
                      <div class="row">
                        <span class="label">药品用法：</span>
                        <span class="text">
                          {{ getKeyValueText('chinese_drug_usage', form.chineseDrugUsage) }}
                        </span>
                      </div>
                      <div class="row">
                        <span class="label">包装量：</span>
                        <span class="text">{{ form.packageNumber }}</span>
                      </div>
                      <div class="row special">
                        <span class="label">处方说明：</span>
                        <span class="text">
                          {{ form.prescripDesc || '--' }}
                        </span>
                      </div>
                    </div>
                  </template>
                </uni-list-item>
              </div>
              <div class="card_wrap">
                <div class="fst_row">
                  <span class="label">煎药信息</span>
                  <span class="text" @click="updateBoilMsg">编辑</span>
                </div>
                <uni-list-item :border="false" :clickable="true">
                  <template v-slot:header>
                    <!-- 宁城县中心医院 -->
                    <div v-if="['28770'].includes(hospitalID)" style="width: 100%">
                      <div class="row">
                        <span class="label">煎药方式：</span>
                        <span class="text">
                          {{ getKeyValueText('process_mode', form.processMode) }}
                        </span>
                      </div>
                    </div>
                    <div v-else style="width: 100%">
                      <div class="row">
                        <span class="label">加工方式：</span>
                        <span class="text">
                          {{ getKeyValueText('process_method', form.processMethod) }}
                        </span>
                      </div>
                      <div class="row">
                        <span class="label">煎药方式：</span>
                        <span class="text">
                          {{ getKeyValueText('process_mode', form.processMode) }}
                        </span>
                      </div>
                      <div class="row special">
                        <span class="label">煎药方案：</span>
                        <span class="text">
                          {{ getKeyValueText('prescrip_solution', form.processSolution) }}
                        </span>
                      </div>
                    </div>
                  </template>
                </uni-list-item>
              </div>
            </div>
            <div class="lead_wrap">
              <!-- prescripType === '4' ? 'lead_img_my' : 'lead_img'  leadImgUrl-->
              <img
                v-if="prescripType !== '7'"
                class="lead_img"
                :src="leadImgUrl"
                @click="leadDrug"
              />
              <!-- 一人一方按钮-蒙药特有 -->
              <!-- <img
                v-if="prescripType === '4'"
                class="lead_img_my lead_margin"
                @click="leadDrugRight"
                src="@funcPuzzle/mini_doctor/AOnePerson.png"
              /> -->
            </div>
          </div>
        </div>
        <div class="estimate_wrap">
          <span class="title">预估药费：</span>
          <span>
            <span class="tag">¥</span>
            <span class="price">{{ showPrice }}</span>
          </span>
        </div>
        <div>
          <div class="bottom">
            <div v-if="prescripType !== '7'" class="footer-box" @click="draftSaveEvent">
              <span class="btn">草稿保存</span>
            </div>
            <div
              :class="prescripType !== '7' ? 'footer-box' : 'oneperson_style'"
              @click="createPrescrip"
            >
              <span class="btn">提交处方</span>
            </div>
          </div>
        </div>
        <template v-slot:close>
          <uni-icons type="closeempty" color="#666" @click="close" />
        </template>
      </uni-card>
    </uni-popup>
    <ms-add-drug
      ref="drug"
      v-model:visible="showAddDrug"
      :prescrip-type="prescripType"
      :warehouseID="pharmacy"
    />
    <!-- 修改处方用法 -->
    <ms-set-usage v-model="showUsage" @closeUsage="onUpdateFormData" />
    <!--  修改煎药信息 -->
    <ms-set-boilmsg
      ref="boilmsg"
      :boilMsg="form"
      :prescripType="prescripType"
      @boilData="boilData"
    />
    <ms-lead-drug
      ref="leadDrug"
      v-model:visible="showLeadDrug"
      :prescripType="prescripType"
      :diagnosis="symptomName"
      :patientName="recordItem.patientName"
      :patientID="recordItem.patientID"
      :doctorID="'2956'"
      :warehouseID="pharmacy"
    />
    <ms-drugright-drugtwo
      ref="leadDrugRight"
      v-model:visible="showLeadDrugRight"
      :prescripType="prescripType"
      :diagnosis="symptomName"
      :patientName="recordItem.patientName"
      :patientID="recordItem.patientID"
      :doctorID="'2956'"
      :drugList="drugList"
      :warehouseID="pharmacy"
      @setOnePreDrugs="setOnePreDrugs"
    />
    <ms-drug-msg
      ref="drugmsg"
      :drug-msg="drugMsg"
      v-model:visible="showDrugMsg"
      :warehouseID="pharmacy"
      :ifUpdate="ifUpdate"
      :isCopy="isCopy"
      :prescrip-type="prescripType"
      @showAddDrug="showAddDrugDialog"
    />
    <ms-oneperson-prescription
      ref="prescriptionWithPeople"
      :ifUpdate="ifUpdate"
      v-model:visible="displayControl"
      :dogrobber="onePreEach"
    />
    <!-- 药品库存不足弹窗 -->
    <uni-popup ref="popupDialog" type="dialog">
      <uni-popup-dialog
        type="warn"
        mode="base"
        :content="tip"
        :stockLack="true"
        :before-close="true"
        :showConfirmButton="showConfirmButton"
        @close="closeDialog"
        @confirm="confirmDialog"
      />
    </uni-popup>
    <!-- 中医院合理用药弹窗提示 -->
    <uni-popup ref="reasonDialog" type="dialog">
      <uni-popup-dialog
        type="warn"
        mode="base"
        :content="reasonText"
        :before-close="true"
        :showConfirmButton="reasonBtnStatus"
        @close="closeReasonDialog"
        @confirm="confirmReasonDialog"
      />
    </uni-popup>
    <uni-popup ref="prescripTipPop">
      <div class="popup-wrap">
        <div class="content-wrap">
          <span :class="[prescripType === '4' ? 'mdrug' : 'theSon', 'common']">
            {{ codeDesc }}
          </span>
        </div>
        <div class="have-know" @click="haveKnow">
          <span>我知道了</span>
        </div>
      </div>
    </uni-popup>
    <uni-popup ref="useDialog" type="dialog">
      <uni-popup-dialog
        :showTitle="false"
        mode="base"
        :content="useTip"
        :stockLack="true"
        :confirmText="'知道了'"
        :showConfirmButton="true"
        :showCancelButton="false"
        @confirm="confirmUseDialog"
      />
    </uni-popup>
  </div>
</template>
<script>
import { getKeyValueText, getKeyValue, birthToAge } from '@/views/funcPuzzle/utils/util.js'
import { getDicListByName } from '@/views/funcPuzzle/utils/index.js'

import { mapState } from 'vuex'
import {
  getVisitRecordOnlineDetail,
  aCheckDrugStock,
  getBusinessDicList,
  createPrescrip,
  draftSaving,
  updateDraftSaving,
  getBusinessConfig
} from '@/views/funcPuzzle/utils/index.js'
import { generateMKData } from './generateMKData'
// import MsDrugMsg from '@/views/funcPuzzle/components/ms-drug-msg/ms-drug-msg.vue'
// import MsAddDrug from '@/views/funcPuzzle/components/ms-add-drug/ms-add-drug.vue'
// import MsDrugShow from '@/views/funcPuzzle/components/ms-drug-show/ms-drug-show.vue'
// import MsSetUsage from '@/views/funcPuzzle/components/ms-set-usage/ms-set-usage.vue'
// import MsSetBoilmsg from '@/views/funcPuzzle/components/ms-set-boilmsg/ms-set-boilmsg.vue'
// import MsLeadDrug from '@/views/funcPuzzle/components/ms-lead-drug/ms-lead-drug.vue'
// import MsDrugrightDrugtwo from '@/views/funcPuzzle/components/ms-drugright-drugtwo/ms-drugright-drugtwo.vue'
// import MsOnepersonPrescription from '@/views/funcPuzzle/components/ms-oneperson-prescription/ms-oneperson-prescription.vue'
// import MsSelectDicNew from '@/views/funcPuzzle/components/ms-select-dicNew/ms-select-dicNew.vue'
import { signatureMethod } from '@/utils/signture/index.js'
import { Dialog, Toast } from 'vant'

export default {
  components: {
    // MsDrugMsg,
    // MsAddDrug,
    // MsDrugShow,
    // MsSetUsage,
    // MsSetBoilmsg,
    // MsLeadDrug,
    // MsDrugrightDrugtwo,
    // MsOnepersonPrescription,
    // 'ms-select-dicNew': MsSelectDicNew
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    value: {
      type: [Array, String],
      default: () => {
        return []
      }
    },
    recordItem: {
      type: [Object, String],
      default: ''
    },
    symptomName: {
      type: [Object, String],
      default: ''
    }
  },
  data() {
    return {
      useTip: '',
      codeDesc: '',
      onePreDrugs: '',
      onePreEach: '',
      ifUpdate: false,
      displayControl: false,
      showDrugMsg: false,
      drugMsg: '',
      isImport: false,
      showConfirmButton: false,
      showLeadDrug: false,
      showLeadDrugRight: false,
      validDays: '3',
      pharmacy: '1001',
      showAddDrug: false,
      drugList: [],
      prescripType: '',
      msZheng: false,
      prescripSort: '1',
      canSubmit: true,
      arr: [],
      prescripClass: '1',
      form: {
        herbFrequence: '',
        herbPerDoseTimes: '',
        chineseDrugUsage: '',
        times: '',
        processMethod: '',
        packageNumber: '',
        processMode: '',
        processSolution: '',
        prescripDesc: '',
        doesNumber: ''
      },
      isOpen: false,
      showPrescripclass: false,
      isShowLead: true,
      haveDoneLead: false,
      isNew: false,
      tip: '',
      submitParam: '',
      leadImgUrl: require('@funcPuzzle/mini_doctor/leadingTwo.png'),
      templateType: '',
      reasonText: '',
      reasonBtnStatus: false,
      preOpinion: '', // 合理用药建议
      tempPrescripRes: null,
      prescripTemplateNum: '',
      prescripTemplateName: '',
      showUsage: false,
      isCopy: false,
      isUpdate: false,
      drugPrice: '',
      timer: '',
      prescripClassList: [], //处方种类
      updateDrugIndex: 0,
      mode: '',
      confirmClick: false,
      stockRes: '',
      tempSubmitData: {}
    }
  },
  computed: {
    ...mapState('user', ['userInfos']),
    hospitalID() {
      return this.userInfos && this.userInfos.hospitalID
    },
    sysList() {
      return this.symptomName
    },
    showPrice() {
      return this.drugPrice ? this.drugPrice.toFixed(2) : '--'
    },
    pharmacyTemp() {
      return this.$store.state.pharmacyTemp && this.$store.state.pharmacyTemp[this.pharmacy]
        ? this.$store.state.pharmacyTemp[this.pharmacy]
        : []
    },
    pharmacyTempPrice() {
      return this.$store.state.pharmacyTempPrice &&
        this.$store.state.pharmacyTempPrice[this.pharmacy]
        ? this.$store.state.pharmacyTempPrice[this.pharmacy]
        : ''
    }
  },
  watch: {
    drugList: {
      handler(val) {
        if (['1', '2', '8'].includes(this.prescripType)) {
          this.drugPrice = val.reduce(function (total, cur) {
            return total + cur.drugPrice * cur.amount
          }, 0)
        } else if (['3', '5', '6'].includes(this.prescripType) && this.form.doesNumber) {
          this.calcZhDrugPrice(val, this.form.doesNumber)
        } else if (['4', '7'].includes(this.prescripType)) {
          this.drugPrice = val.reduce(function (total, cur) {
            return total + cur.drugPrice * cur.amount
          }, 0)
        }
      },
      deep: true
    },
    pharmacy: {
      handler(val, old) {
        if (old) {
          this.drugList.price = this.drugPrice // 记录药品价格
          this.$store.commit('SET_PHARMACY_TEMP', {
            key: old,
            data: this.drugList
          })
          this.drugList = []

          // tempPrice[old] = { drugPrice: this.drugPrice }
        }
        if (this.pharmacyTemp && this.pharmacyTemp[0]) {
          this.drugList = [...this.pharmacyTemp]
          this.drugPrice = this.pharmacyTemp.price // 药品价格
        } else {
          this.drugList = []
          this.drugPrice = ''
        }

        // if (this.pharmacyTempPrice) {
        //   this.drugPrice = this.pharmacyTempPrice.drugPrice
        // } else {
        //   this.drugPrice = ''
        // }
      },
      immediate: true
    },
    'form.doesNumber': {
      handler(val) {
        if (val) {
          this.$bus.emit('doesNumber', val)
          this.calcZhDrugPrice(this.drugList, val)
        } else {
          if (['3', '5', '6'].includes(this.prescripType)) {
            this.drugPrice = ''
          }
        }
      },
      immediate: true
      // deep: true
    },
    visible: {
      handler(val) {
        if (val) {
          this.$store.commit('DEL_PHARMACY_TEMP') // 清楚当前缓存药品
          this.isShowLead = this.isNew ? true : false
          this.isOpen = false
          this.open()

          this.fetchDrugDaysConfig()
        } else {
          this.$store.commit('DEL_PHARMACY_TEMP')

          this.close()
        }
        const { prescripClassList } = this
        if (prescripClassList && prescripClassList.length == 0) {
          this.getPrescripClassList()
        }
      }
    },
    prescripType: {
      handler(val) {
        if (val === '4') {
          this.$bus.emit('isMengPre', true)
        } else {
          this.$bus.emit('isMengPre', false)
          if (val === '3' || val === '5') {
            this.form =
              this.isUpdate || this.isCopy
                ? Object.assign(this.form, {
                    herbFrequence: this.newValue.herbFrequence,
                    herbPerDoseTimes: this.newValue.herbPerDoseTimes,

                    chineseDrugUsage: this.newValue.chineseDrugUsage,
                    times: this.newValue.times,
                    processMethod: this.newValue.processMethod,
                    packageNumber: this.newValue.packageNumber,
                    processMode: this.newValue.processMode,
                    processSolution: this.newValue.processSolution,
                    doesNumber: this.newValue.doesNumber,
                    prescripDesc: this.newValue.prescripDesc
                  })
                : {
                    herbFrequence: '',
                    herbPerDoseTimes: '',

                    chineseDrugUsage: '',
                    times: '2',
                    processMethod: '1',
                    packageNumber: '',
                    // processMode: 'A001',
                    processMode: '',
                    processSolution: '02',
                    doesNumber: ''
                  }
          } else if (val === '6') {
            this.form =
              this.isUpdate || this.isCopy
                ? Object.assign(this.form, {
                    herbFrequence: this.newValue.herbFrequence,
                    herbPerDoseTimes: this.newValue.herbPerDoseTimes,

                    chineseDrugUsage: this.newValue.chineseDrugUsage,
                    times: this.newValue.times,
                    processMethod: this.newValue.processMethod,
                    packageNumber: this.newValue.packageNumber,
                    processMode: this.newValue.processMode,
                    processSolution: this.newValue.processSolution,
                    doesNumber: this.newValue.doesNumber,
                    prescripDesc: this.newValue.prescripDesc
                  })
                : {
                    herbFrequence: '',
                    herbPerDoseTimes: '',

                    chineseDrugUsage: 'C',
                    times: '',
                    processMethod: '2',
                    packageNumber: '',
                    // processMode: 'A001',
                    processMode: '',
                    processSolution: '',
                    doesNumber: ''
                  }
          }
        }
        // 一人一方展示判定
        val === '4'
          ? (this.leadImgUrl = require('@funcPuzzle/mini_doctor/leadingTwo.png'))
          : (this.leadImgUrl = require('@funcPuzzle/mini_doctor/leadingTwo.png'))
      },
      immediate: true
    },
    recordItem: {
      handler(val) {},
      immediate: true
    }
  },
  beforeUnmount() {
    this.$bus.off('doesNumber')
  },
  methods: {
    getKeyValueText,
    // dataFactory,
    getKeyValue,
    birthToAge,
    changePrescripClass(val) {
      this.prescripClass = val
    },
    confirmUseDialog() {
      this.$refs.useDialog.close()
      return false
    },
    setCopyPrescrip(val, val2) {
      console.log('setCopyPrescrip')
      this.prescripNum = 0 //清空处方单好
      this.isCopy = true
      this.newValue = val
      this.form.doesNumber = val.doesNumber

      this.setPrescripClass(val.prescripClass)
      this.prescripSort = val2 + 1 + ''
      this.prescripType = val.prescripType
      this.prescripChannel = val.prescripChannel
      this.templateType = val.templateType
      this.prescripTemplateNum = val.prescripTemplateNum
      this.prescripTemplateName = val.prescripTemplateName
      this.drugList = val.prescripDrugsInfoList.map((item, i) => {
        item.drugFlag = new Date().getTime() + i
        return item
      })
      console.log('drugList', this.drugList)
      this.validDays = val.validDays
      this.pharmacy = val.warehouseID
      // eslint-disable-next-line vue/no-mutating-props
      // this.recordItem = Object.assign(this.recordItem, {
      //   patientName: val.patientName,
      //   patientSex: val.sex,
      //   symptomName: val.diagnosis,
      //   patientAge: val.age
      // })
      this.$emit('update:recordItem', {
        ...this.recordItem,
        patientName: val.patientName,
        patientSex: val.sex,
        symptomName: val.diagnosis,
        patientAge: val.age
      })
    },
    // 获取用药天数限制的配置
    async fetchDrugDaysConfig() {
      try {
        const res = await getBusinessConfig('use_drug_days_limit', this.hospitalID)
        if (res.code === 0) {
          const conf =
            res.DoctorServicePackageList && res.DoctorServicePackageList[0]
              ? res.DoctorServicePackageList[0]
              : null

          if (conf) {
            localStorage.setItem('UseDrugDaysConfig', JSON.stringify(conf.value))
            // uni.setStorage({
            //   key: 'UseDrugDaysConfig',
            //   data: conf.value,
            //   success: function () {}
            // })
          }
        }
      } catch (error) {
        console.log(error)
      }
    },
    prescripTipOpen() {
      this.$refs.prescripTipPop.open()
    },
    haveKnow() {
      this.$refs.prescripTipPop.close()
    },
    showAddDrugDialog() {
      this.showAddDrug = true
      this.$refs.cPrescrip.close()
      console.log('cPrescrip---', this.$refs.cPrescrip)
    },
    calcZhDrugPrice(val, doesNumber) {
      val = val.map(item => {
        item.doesNumber = doesNumber
        return item
      })

      this.drugPrice = val.reduce(function (total, cur) {
        return cur.packageUnit === '09'
          ? total + (cur.drugPrice * cur.doesNumber * Number(cur.useAuantity)) / cur.packageNumber
          : total +
              (cur.drugPrice * cur.doesNumber * Number(cur.useAuantity)) /
                cur.packageNumber /
                cur.mindoseUnit
      }, 0)
    },
    getPrescripClassList() {
      getDicListByName('prescrip_class_v2').then(res => {
        this.prescripClassList = res.dicList
        this.prescripClass = this.prescripClassList[0].code
      })
    },
    leadDrug() {
      if (!this.sysList[0]) {
        Toast({
          title: '请先添加诊断',
          icon: 'none'
        })
        return false
      }
      if (this.msZheng && this.drugList.length > 0) {
        Modal({
          title: '提示',
          content: '继续操作的话，您之前已编辑的内容将会被替换，您确定继续？',
          success: res => {
            if (res.confirm) {
              this.drugList.splice(0, this.drugList.length)
              this.gear()
            } else if (res.cancel) {
              return false
            }
          }
        })
      } else {
        this.gear()
      }
    },
    gear() {
      this.msZheng = false
      this.isShowLead = false
      // 一人一方标识关闭
      this.showLeadDrug = true
      // this.$refs.leadDrug.open()

      this.close()
    },
    leadDrugRight() {
      if (!this.sysList[0]) {
        Toast({
          title: '请先添加诊断',
          icon: 'none'
        })
        return false
      }
      if (this.drugList.length > 0) {
        Modal({
          title: '提示',
          content: '继续操作的话，您之前已编辑的内容将会被替换，您确定继续？',
          success: res => {
            if (res.confirm) {
              this.drugList.splice(0, this.drugList.length)
              this.gearTwo()
            } else if (res.cancel) {
              return false
            }
          }
        })
      } else {
        this.gearTwo()
      }
    },
    gearTwo() {
      this.msZheng = true
      this.isShowLead = false
      this.$refs.leadDrugRight.open()

      this.close()
    },
    boilData(val) {
      this.form.processMethod = val.processMethod
      this.form.processMode = val.processMode
      this.form.processSolution = val.processSolution
      this.form.packageNumber = this.form.processMethod === '0' ? 200 : ''
    },
    updateUsage() {
      // 打开编辑处方用法
      this.showUsage = this.form
      this.$bus.emit('doesNumber', this.form.doesNumber)
      // 关闭处方弹框
      this.close()
    },
    onUpdateFormData(data = {}) {
      // 更新处方用法数据
      this.form = Object.assign({}, this.form, data)
      // 打开处方弹框
      this.open()
    },
    updateBoilMsg() {
      this.$refs.boilmsg.open()

      this.close()
    },
    selectPrescripClass() {
      this.$refs.prescripclass.open()
    },
    setPrescripClass(val) {
      this.$bus.emit('prescripClass', val)
      this.prescripClass = val
    },
    getCal(val) {
      return typeof val
    },
    selectPre(i) {
      this.selectedIndex = i
    },
    close(isClearData) {
      if (!this.$refs.cPrescrip) {
        return false
      }
      const { isUpdate } = this
      // 如果点击修改处方后关闭 需要重置数据
      if (isUpdate === true && isClearData === true) {
        this.$bus.emit('updatePrescrip', { val: {}, val2: '1' })
      }
      this.$emit('update:visible', false)
      this.$refs.cPrescrip.close()
      this.isNew = false
      this.isCopy = false
      this.isUpdate = false
    },
    open() {
      // this.$emit('update:visible', true)
      setTimeout(() => {
        this.$refs.cPrescrip.open()
      }, 400)
    },
    checkOne(e) {
      this.validDays = e.detail.value
    },
    changePharmacy(e) {
      this.pharmacy = e.detail.value
    },
    addDrug() {
      if (!this.sysList[0]) {
        Toast({
          title: '请先添加诊断',
          icon: 'none'
        })
        return false
      }
      if (this.msZheng && this.drugList.length > 0) {
        Modal({
          title: '提示',
          content: '继续操作的话，您之前已编辑的内容将会被替换，您确定继续？',
          success: res => {
            if (res.confirm) {
              this.templateType = ['1', '2'].includes(this.templateType) ? this.templateType : ''
              this.drugList.splice(0, this.drugList.length)
              this.gearThree()
            } else if (res.cancel) {
              return false
            }
          }
        })
      } else {
        this.gearThree()
      }
    },
    setOnePreDrugs(val) {
      this.onePreDrugs = val.drugs
    },
    editDrug({ drugShowList, index, ifOne }) {
      // console.log(drugShowList, index, ifOne, 'editDrug-----------')
      this.ifUpdate = true
      this.$refs.cPrescrip.close()
      if (ifOne) {
        const controller = {
          exhibition: true,
          templateType: this.templateType,
          prescripTemplateNum: this.prescripTemplateNum,
          prescripName: this.prescripTemplateName,
          useDrugTime: drugShowList[0].useDrugTime,
          timeMachine: 7
        }
        this.onePreEach = {
          ...{ drugs: JSON.stringify(drugShowList) },
          ...controller,
          ...{ useDrugTime: drugShowList[0].useDrugTime }
        }
        this.$refs.prescriptionWithPeople.open()
      } else {
        this.updateDrugIndex = index
        this.drugList = [...drugShowList] // 更新一下当前drugList，不让你这个index和drugList索引值不一样
        this.drugMsg = drugShowList[index]
        this.showDrugMsg = true
      }
    },
    gearThree() {
      this.msZheng = false

      this.prescripType === '7' ? (this.showLeadDrugRight = true) : (this.showAddDrug = true)
      this.$refs.cPrescrip.close()
      this.$bus.emit('doesNumber', this.form.doesNumber)
    },
    groupBy(arr, key) {
      const obj = {}
      arr.sort((a, b) => a[key] - b[key])
      arr.map(item => {
        const _key = item[key]
        if (obj[_key]) {
          obj[_key].push(item)
        } else {
          obj[_key] = [item]
        }
      })
      return obj
    },
    judgeList(val) {
      this.arr = val.filter(item => {
        return item.drugID
      })
      const groupObj = this.groupBy(this.arr, 'useDrugTime')

      const finArr = []
      for (const i in groupObj) {
        finArr.push(groupObj[i])
      }

      finArr
        .filter(value => {
          return value.length === 1
        })
        .filter(item => {
          if (item[0].isDrugInducer && item[0].isDrugInducer !== '0') {
            Toast({
              title: '提交失败，只有药引没有对应的药品信息',
              icon: 'none'
            })
            this.canSubmit = false
          }
        })
      return this.canSubmit
    },
    draftSaveEvent() {
      this.mode = 'draftSaving'
      this.commonFunc()
    },
    // 草稿保存和提交处方公共逻辑
    commonFunc() {
      // uni.showLoading({
      //   title: '保存中',
      //   icon: 'none'
      // })
      if (!this.drugList[0]) {
        Toast({
          title: '请添加药品',
          icon: 'none'
        })
        return false
      }
      if (!this.form.chineseDrugUsage && ['3', '5', '6'].includes(this.prescripType)) {
        Toast({
          title: '请选择药品用法',
          icon: 'none'
        })
        return
      }
      // 宁城中心医院，校验药品用法、频率、煎药方式
      if (['28770'].includes(this.hospitalID) && ['3', '5', '6'].includes(this.prescripType)) {
        console.log(['28770'].includes(this.hospitalID), 'this.hospitalID')
        console.log(this.form, 'this.form')
        if (!this.form.herbFrequence) {
          Toast({
            title: '请选择频率',
            icon: 'none'
          })
          return
        }
        if (!this.form.processMode) {
          Toast({
            title: '请选择煎药方式',
            icon: 'none'
          })
          return
        }
      }
      this.canSubmit = true
      if (
        this.drugList.length === 1 &&
        (this.drugList[0].isDrugInducer === '1' ||
          this.drugList[0].isDrugInducer === true ||
          this.drugList[0].isDrugInducer === 'true') &&
        this.prescripType === '4'
      ) {
        Toast({
          title: '提交失败，只有药引没有对应的药品信息',
          icon: 'none'
        })
        return false
      }
      // const drugList = JSON.parse(JSON.stringify(this.drugList))
      const drugList = [...this.drugList]

      //药品数量大于1，并且处方类别不是蒙药 (prescripType 不等于 4)，需要校验药品是否重复
      if (this.prescripType != 4 && drugList.length > 1) {
        // 拷贝数据 防止改变原数据
        const stagingDrugList = JSON.parse(JSON.stringify(drugList))
        //   数组根据drugID排序
        stagingDrugList.sort(function (a, b) {
          return a.drugID > b.drugID ? 1 : -1
        })

        // 判断是数组重复并提示
        let repeatMessage = ''
        for (let i = 0; i < stagingDrugList.length - 1; i++) {
          if (stagingDrugList[i].drugID == stagingDrugList[i + 1].drugID) {
            repeatMessage =
              repeatMessage == ''
                ? `${repeatMessage}${stagingDrugList[i].drugName}`
                : `${repeatMessage}、${stagingDrugList[i].drugName}`
          }
        }
        // 提示文案不为空，有重复
        if (repeatMessage != '') {
          // uni.hideLoading()
          Dialog({
            title: '提示',
            showCancel: false,
            content: `【${repeatMessage}】药品重复，请修改`,
            confirmText: '知道了'
          })
          return false
        }
      }
      drugList.map(item => {
        item.id = ''
        item.visitID = this.recordItem.visitID
        if (this.prescripType === '3' || this.prescripType === '5' || this.prescripType === '6') {
          item.useDays = '1'
          item.amount = Math.ceil(this.form.doesNumber * Number(item.useAuantity))
        }

        return item
      })

      const obj = {
        id: this.recordItem.id,
        prescripType: this.prescripType,
        validDays: this.validDays,
        warehouseID: this.pharmacy,
        prescripSort: this.prescripSort,
        prescripClass: this.prescripClass,
        prescripNum: this.prescripNum,
        // 模板类型 一人一方时必传
        templateType: this.templateType,
        prescripTemplateNum: this.prescripTemplateNum,
        prescripTemplateName: this.prescripTemplateName,
        doesNumber: this.form.doesNumber
      }

      // 提交处方 药品参数名：DrugList 草稿保存叫：drugs
      let submitParam =
        this.mode === 'createPrescrip'
          ? { ...obj, DrugList: drugList }
          : { ...obj, drugs: drugList }

      if (this.prescripType === '3' || this.prescripType === '5' || this.prescripType === '6') {
        submitParam = Object.assign(submitParam, this.form)

        if (submitParam.doesNumber === '0' || !submitParam.doesNumber) {
          Toast({
            title: '请填写服药剂数',
            icon: 'none'
          })
          return false
        }
      }
      if (!this.judgeList(drugList)) {
        return false
      }
      this.checkDrugStock(submitParam, drugList)
    },
    createPrescrip() {
      this.mode = 'createPrescrip'
      this.commonFunc()
    },
    checkDrugStock(submitParam, drugList) {
      this.submitParam = submitParam
      let arr = []
      arr = drugList.map(item => {
        return {
          drugId: item.drugID,
          drugName: item.drugName,
          drugType: item.drugType,
          amount: Number(item.amount),
          warehouseID: this.pharmacy
        }
      })

      arr = [...this.reduceAmount(arr)]

      const params = { drugs: arr, flag: '1' }

      aCheckDrugStock(params).then(rs => {
        if (rs.DrugList && rs.DrugList[0]) {
          rs.DrugList = rs.DrugList.map((item, index) => {
            arr.filter(val => {
              // 某个药品库存不足
              if (item.drugID === val.drugId && Number(val.amount) > Number(item.stockQuantity)) {
                rs.DrugList[index].isLack = true
                rs.DrugList[index].drugName = val.drugName
              }
            })
            return item
          })
          this.stockRes = rs
        } else if ([-1, -2].includes(rs.code) && !rs.DrugList) {
          // uni.hideLoading()
          this.codeDesc = rs.codeDesc || rs.msg
          // 失败弹窗提示
          this.prescripTipOpen()
          return false
        }
        this.drugList = drugList
        this.submitParam = submitParam
        let name = ''
        const array = []
        //提交的时候isOpen需要先设置成false，否则第一次库存不足会导致修改后库存足够的信息依旧无法通过检验
        this.isOpen = false

        for (let i = 0; i < rs.DrugList.length; i++) {
          if (rs.DrugList[i].isLack) {
            name = rs.DrugList[i].drugName
            array.push(name)
            this.isOpen = true
          }
        }
        const msg =
          this.mode === 'createPrescrip'
            ? '库存不足，确定要继续开方吗？'
            : '库存不足，确定要继续保存草稿吗？'
        this.tip = array.join(',') + msg
        // 只有是院内药房的时候 才提示库存不足
        if (this.isOpen && this.pharmacy == '1001') {
          // uni.hideLoading()
          this.getBusinessStore()
        } else {
          this.judgeOpenIssuablePopup(this.stockRes, this.drugList, this.submitParam)
        }
      })
    },
    afterFunc(submitParam, drugList) {
      if (this.hospitalID === '27971' || this.hospitalID === '1886') {
        this.isZLandHS(submitParam, drugList)
      } else {
        this.modeJudge(submitParam)
      }
    },
    reduceAmount(arr) {
      // 按照drugID进行分组 并将amount进行累加 然后将值放到数组中
      const lastArr = JSON.parse(JSON.stringify(arr))
      const newArr = Object.values(
        lastArr.reduce((acc, cur) => {
          const { drugID, drugId, amount } = cur
          if (!acc[drugID || drugId]) {
            acc[drugID || drugId] = cur
          } else {
            acc[drugID || drugId].amount += amount
          }
          return acc
        }, {})
      )

      return newArr
    },
    issuablePopup(drugList, rs, submitParam) {
      const array = []
      // 筛选出dailyConsumption不为空的
      drugList.forEach(item => {
        rs.DrugList.some(val => {
          // 查询出相同drugID的药品 并给drugList中药品的useConsumption和dailyConsumption赋值
          // 这个时候查到的这两个值是最新的
          if (item.drugID === val.drugID) {
            item.useConsumption = val.useConsumption
            item.dailyConsumption = val.dailyConsumption
          }
        })
      })

      drugList = drugList.map(item => {
        item.amount = Number(item.amount)
        return item
      })
      drugList = [...this.reduceAmount(drugList)]
      // this.reduceAmount(drugList)

      drugList = drugList.filter(item => {
        return item.dailyConsumption || item.dailyConsumption == 0
      })

      const have = drugList.some(
        item => item.dailyConsumption - Number(item.useConsumption) < item.amount
      )

      drugList.forEach(item => {
        const base = item.dailyConsumption - Number(item.useConsumption) < item.amount

        // 中草药类型 需要this.form.doesNumber 有的情况下 才判断
        const condition = ['4', '5', '6'].includes(item.drugType)
          ? base && this.form.doesNumber
          : base
        // 如果药品发药数量超过了可开具数量
        if (condition) {
          const unit = this.switchFunc(item)
          // 将对多个药品的提示放到数组中
          array.push(
            `${item.commonName || item.drugName} 单日消耗总量限制为 【${
              item.dailyConsumption
            }】${unit}，当前可开具【${
              item.dailyConsumption > item.useConsumption
                ? item.dailyConsumption - item.useConsumption
                : 0
            }】${unit}，您开具的【${item.amount}】${unit}已超量。`
          )

          uni.hideLoading()
          // 校验药品发药数量是否超过可开具数量弹窗提示
          this.$refs.useDialog.open()

          return false
        }
      })

      // 处方药品都符合可开具数量的需求时 继续后续的开方操作
      if (!have) {
        this.afterFunc(submitParam, drugList)
      }

      this.useTip = array.join('\n')
    },
    switchFunc(item) {
      // 中成药、西药、蒙药 用的是packageUnit
      const chinesePatentVals = ['1', '2', '8']
      // 中草药、小包装、中药颗粒 用的是measureUnit
      const chineseHerbalVals = ['4', '5', '6']
      switch (item.drugType) {
        case chinesePatentVals[0]:
        case chinesePatentVals[1]:
        case chinesePatentVals[2]:
          return getKeyValueText('package_unit', item.packageUnit)
        // 蒙药（蒙）用的是packageUnit
        case '3':
          return getKeyValueText('package_unit_meng', item.packageUnit)
        case chineseHerbalVals[0]:
        case chineseHerbalVals[1]:
        case chineseHerbalVals[2]:
          return getKeyValueText('measure_unit', item.measureUnit)
      }
    },
    // 查询业务配置，是否开启前置审方
    async isZLandHS(submitParam, drugList) {
      try {
        const res = await getBusinessConfig('preAuditPrescription', this.hospitalID)
        if (res.code === 0) {
          if (res.DoctorServicePackageList[0]) {
            const config = JSON.parse(res.DoctorServicePackageList[0].value)
            // 根据药房id判断是否开启前置审方
            // 20230412 改
            if (config[this.pharmacy].level == 0) {
              this.modeJudge(submitParam)

              return
            }
          }
        }

        this.mkReview(submitParam, drugList)
      } catch (error) {
        console.error(error)
      }
    },
    /**
     * @description 美康前置审方校验
     * @param {*} submitParam
     * @param {*} drugList
     */
    mkReview(submitParam, drugList) {
      this.tempSubmitData = submitParam

      const mkviewData = generateMKData(this.recordItem, drugList)

      uni.navigateTo({
        url: `/subpackage/pages/mkpage/mkwebview?params=${encodeURIComponent(
          JSON.stringify(mkviewData)
        )}`
      })

      // plugin.setCallBack(mkres => {
      //   uni.showLoading({
      //     title: '保存中',
      //     icon: 'none'
      //   })
      //   //返回opt审查结果对象
      //   const checkStatus = mkres.taskResult
      //   // const MDC_GetSysPrStatus_param = mkres.MDC_GetSysPrStatus_param
      //   // const prDa = MDC_GetSysPrStatus_param.prDa || []
      //   if (checkStatus === -2) {
      //     uni.hideLoading()
      //     uni.showToast({
      //       title: '请修改后提交',
      //       icon: 'none'
      //     })
      //   } else {
      //     if (mkres.slcode > 0) {
      //       submitParam.preOpinion = `合理用药审核不通过，请药师人工审核`

      //       this.modeJudge(submitParam)
      //     } else {
      //       this.modeJudge(submitParam)
      //     }
      //   }
      // })

      // plugin.setCheckData(mkdata)
      // console.log('mkdata', qs.stringify(mkdata))
      // console.log('mkdata', JSON.stringify(mkdata))
      // wx.navigateTo({
      //   url: 'plugin://mcPlugin/check'
      // })
      // （-2返回修改；-1待药师审核；0不通过；1通过）
      //HIS通过解析回调taskResult返回值控制后续处方保存流程。
      // {"slcode":1,"isFullFill":2,"taskResult":0,"MDC_GetSysPrStatus_param":{"ShouldBlock":0,"prDa":[{"Status":-5,"OverTime":86400,"PassTime":0,"Paused":0,"Reason":"","MHisCode":0,"CaseID":"0_4_Q1001__01","TaskId":"202201041331559998","StatusNo":"","Mobile":"","TelePhone":"","DeptTelePhone":"","Urgent":-1,"NeedAutoApply":0,"NeedApply":0,"NeedAutoIntervene":0,"NeedCounterSign":1,"NeedUseReason":2,"FillInDoubleSignatureReason":1,"WorkerId":"","WorkerName":"","StatusDesc":"医生提请药师审核","Type":2,"OrderNum":"","WorkType":1,"PharmAddQuestion":0,"SubTaskMode":0,"ListSubTaskStatus":"","DisplaySetting":0,"ScoreFeedBack":0,"CheckDoctorModify":0,"DoctorReasonRecords":"","NewUseReason":"","DrugUseReason":"","Mark":0,"MarkOpinion":"","IsHLW":true,"CASign":{"CertId":"","UserCert":"","SignValue":"","SignImg":"","InData":"","InBase64Data":"","TsData":"","SignTime":""}}]},"err":""}

      // return false
    },
    modeJudge(submitParam) {
      this.mode === 'createPrescrip'
        ? this.createPre(submitParam)
        : this.draftSavingFunc(submitParam)
    },
    getBusinessStore() {
      getBusinessDicList({
        pageNum: 1,
        pageSize: 1,
        tableName: 'enabled_precrip_on_not_enogh_stock',
        code: ''
      }).then(rs => {
        // 不展示确定按钮
        const cannotCreate = JSON.parse(
          rs.DoctorServicePackageList[0].value
        ).enablePrecripHospital.find(item => item.hospitalID === this.hospitalID)

        this.showConfirmButton = cannotCreate ? false : true
        this.$refs.popupDialog.open()
      })
    },
    // 药品库存不足取消
    closeDialog() {
      // uni.hideLoading()
      this.$refs.popupDialog.close()
      return false
    },
    judgeOpenIssuablePopup(rs, drugList, submitParam) {
      // 判断查询到的库存接口返回中 dailyConsumption是否有值
      rs.DrugList = rs.DrugList.filter(item => {
        return item.dailyConsumption || item.dailyConsumption == 0
      })

      // dailyConsumption有值或者值为0 并且是开处方功能 才进行提示
      if (rs.DrugList[0] && this.mode === 'createPrescrip') {
        this.issuablePopup(drugList, rs, submitParam)
      } else {
        // 后续开方方法
        this.afterFunc(submitParam, drugList)
      }
    },
    confirmDialog() {
      // 点击确定按钮 库存不足 继续开方
      this.judgeOpenIssuablePopup(this.stockRes, this.drugList, this.submitParam)
      this.$refs.popupDialog.close()
      // this.close()
    },
    /* 草稿保存方法 */
    draftSavingFunc(submitParam, prescripNum) {
      // 忽略库存校验参数 传true 库存校验全由前端来处理
      const { patientID, hospitalID, visitID } = this.recordItem
      const baseObj = {
        ...submitParam,
        ...{ patientID, hospitalID, visitID },
        ...{ prescripChannel: this.prescripChannel },
        ...{ ignoreDrugStockValidation: true }
      }
      // 忽略合理用药参数 中医院传false 其他医院传true
      let params =
        hospitalID === '27216'
          ? {
              ...baseObj,
              ignoreRationalDrugUseInspection: this.confirmClick ? true : false
            }
          : {
              ...baseObj,
              ignoreRationalDrugUseInspection: true
            }
      if (prescripNum) {
        params = { ...submitParam, ...prescripNum }
      }
      params.platformId = '2'
      if (!this.isUpdate) {
        draftSaving(params)
          .then(res => {
            this.commonHandles(params, res)
          })
          .catch(error => {
            this.codeDesc = '保存草稿处方请求失败，请稍后重试'
            this.prescripTipOpen()
          })
      } else {
        updateDraftSaving(params)
          .then(res => {
            this.commonHandles(params, res)
          })
          .catch(error => {
            this.codeDesc = '修改草稿处方请求失败，请稍后重试'
            this.prescripTipOpen()
          })
      }
    },
    commonHandles(params, res) {
      this.tempPrescripRes = params
      // uni.hideLoading()
      if (res.code === 0) {
        // if (true) {
        this.$refs.cPrescrip.close()
        this.getDetail(res.data.prescripNum)
        this.$bus.emit('showPrescription')
      } else {
        // 药品信息无效拦截
        if (res.code === -5) {
          this.codeDesc = res.codeDesc
          this.prescripTipOpen()
          return
        }
        // 中医院——合理用药判断
        if (this.hospitalID === '27216') {
          if (res.code === -2) {
            this.reasonText = res.codeDesc + '是否继续？'
            this.preOpinion = res.codeDesc
            this.reasonBtnStatus = true
            this.$refs.reasonDialog.open()
            return false
          }
          if (res.code === -3) {
            this.reasonText = res.codeDesc
            this.reasonBtnStatus = false
            this.$refs.reasonDialog.open()
            return false
          }
          if ([-1, 500].includes(res.code)) {
            this.codeDesc = res.codeDesc

            this.prescripTipOpen()
          }
        } else {
          this.codeDesc = res.codeDesc
          this.prescripTipOpen()
        }
      }
      this.isUpdate = false
      this.confirmClick = false
    },
    async createPre(submitParam, prescripNum) {
      let params = Object.assign({}, submitParam)
      if (prescripNum) {
        params = Object.assign({}, submitParam, prescripNum)
      }
      params.platformId = '2'
      createPrescrip(params)
        .then(res => {
          this.tempPrescripRes = params
          // uni.hideLoading()
          if (res.code === 0) {
            this.close()
            this.getDetail(res.prescripNum)
            this.$bus.emit('showPrescription')
          } else {
            // 药品信息无效拦截
            if (res.code === -5) {
              this.codeDesc = res.codeDesc
              this.prescripTipOpen()
              return
            }
            if (res.code === -4) {
              this.needSign(res, submitParam)
              return
            }
            // 中医院——合理用药判断
            if (this.hospitalID === '27216') {
              if (res.code === -2) {
                this.reasonText = res.codeDesc + '是否继续？'
                this.preOpinion = res.codeDesc
                this.reasonBtnStatus = true
                this.$refs.reasonDialog.open()
                return false
              }
              if (res.code === -3) {
                this.reasonText = res.codeDesc
                this.reasonBtnStatus = false
                this.$refs.reasonDialog.open()
                return false
              }
              if (res.code === -1) {
                this.codeDesc = res.codeDesc
                this.prescripTipOpen()
              }
            } else {
              this.codeDesc = res.codeDesc
              this.prescripTipOpen()
            }
          }
        })
        .catch(error => {
          this.codeDesc = '保存处方请求失败，请稍后重试'
          this.prescripTipOpen()
        })
    },
    getDetail(prescripNum) {
      getVisitRecordOnlineDetail({
        visitID: this.recordItem.visitID
      }).then(res => {
        this.prescripList = res.PrescripInfoList
        const preItem = this.prescripList.filter(item => {
          return item.prescripNum === prescripNum
        })[0]

        const detail = Object.assign(
          {},
          {
            preItem,
            visitNo: res.reginfo.visitNo,
            symptomName: res.VisitRecordOnlineDetail.symptomName,
            patientPhone: res.VisitRecordOnlineDetail.patientPhone
          }
        )
        this.$bus.emit('prescripDetail', detail)
      })
    },
    needSign(res) {
      const _this = this
      const signMethod = new signatureMethod({
        flowId: res?.flowId, // e签宝使用，后台返回
        accountId: res?.accountId, // e签宝使用，后台返回
        prescripNum: res.prescripNum, // 处方编号，后台返回
        doctorId: res.doctorId, // 医生ID，后台返回
        signType: res.signType, // 签名类型，后台返回
        signUrl: res.signUrl, // 签名地址，后台返回
        businessType: res.businessType,
        response: res, // 后台返回的数据
        // 查询签名前调用的方法（提示用）
        beforeConfirm() {
          // afterCheckModel() 继续查询
          Dialog({
            title: '提示',
            content: '您好，如若签名未完成，则处方自动存为待提交的草稿状态，请确认签名是否已完成？',
            cancelText: '取消',
            confirmText: '已完成',
            success: res => {
              if (res.confirm) {
                signMethod.afterCheckModel()
              } else {
                _this.$refs.cPrescrip.close()
                _this.getDetail(res.prescripNum)
                _this.$bus.emit('showPrescription')
              }
            }
          })
        },
        // 签名成功时
        signSuccess() {
          _this.$refs.cPrescrip.close()
          _this.getDetail(res.prescripNum)
          _this.$bus.emit('showPrescription')
        },
        // 签名失败时调用
        signFail() {
          _this.$refs.cPrescrip.close()
          _this.getDetail(res.prescripNum)
          _this.$bus.emit('showPrescription')
        },
        // e签宝调用失败
        eSignFail() {
          Dialog({
            content: '因处方未完成签名，所以将自动存为待提交的草稿。',
            confirmText: '知道了',
            showCancel: false,
            success: () => {
              _this.$refs.cPrescrip.close()
              _this.getDetail(res.prescripNum)
              _this.$bus.emit('showPrescription')
            }
          })
        }
      })
    },
    closeReasonDialog() {
      this.$refs.reasonDialog.close()
    },
    confirmReasonDialog() {
      this.$refs.reasonDialog.close()
      // uni.showLoading({
      //   title: '保存中',
      //   icon: 'none'
      // })
      const { preOpinion } = this
      // 如果是草稿保存 忽略合理用药传true 否则status传1
      if (this.mode === 'createPrescrip') {
        this.tempPrescripRes.status = 1
      } else {
        this.tempPrescripRes.ignoreRationalDrugUseInspection = true
        this.confirmClick = true
      }

      // 合理用药提示
      this.tempPrescripRes.preOpinion = preOpinion

      this.mode === 'createPrescrip'
        ? this.createPre(this.tempPrescripRes)
        : this.draftSavingFunc(this.tempPrescripRes)
    },
    /**
     * @description 合理用药监测状态返回
     * @param {*} Status
     */
    reasonableMedicationReturn(Status) {
      const submitParam = this.tempSubmitData
      if (Status === -17) {
        // uni.hideLoading()
        Toast({
          title: '请修改后提交',
          icon: 'none'
        })
      } else if (Status === -5) {
        submitParam.preOpinion = `合理用药审核不通过，请药师人工审核`
        this.modeJudge(submitParam)
      } else {
        this.modeJudge(submitParam)
      }
    }
  },
  mounted() {
    // this.$bus.$on('usageItem', val => {
    //   this.open()
    //   // this.form.chineseDrugUsage = val.chineseDrugUsage
    //   // this.form.times = val.times
    //   // this.form.packageNumber = val.packageNumber
    //   // this.form.prescripDesc = val.prescripDesc
    //   this.form = Object.assign({}, this.form, val)
    //   console.log(this.form, 'usageItem--------')
    // })

    this.$bus.on('boilMsgItem', val => {
      this.open()
      this.form.processMethod = val.processMethod
      this.form.processMode = val.processMode
      this.form.processSolution = val.processSolution
      this.form.packageNumber = this.form.processMethod === '0' ? 200 : ''
    })
    this.$bus.on('drugItem', ({ val, val2 }) => {
      if (!this.isImport) {
        this.templateType = ''
      }
      this.prescripTemplateNum = ''
      this.open()
      const copyList = [...this.drugList]
      // 中成药处方:1 西药处方: 2 中草药处方: 3 蒙药处方: 4 中药小包装处方:5 中药颗粒处方: 6 一人一方: 7 蒙药处方: 8
      console.log('prescripType:', this.prescripType)
      if (val2) {
        // 编辑, 可能会有重复的药品在不同的时段不能根据药品id编辑药品
        if (['4'].includes(this.prescripType)) {
          // 蒙药需要按用药时间+药引排序，编辑后修改放到列表后面
          copyList.splice(this.updateDrugIndex, 1)
          copyList.push(val)
        } else {
          // 默认编辑直接修改当前项即可
          Object.assign(this.drugMsg, val)
        }
      } else {
        // 添加
        copyList.push(val)
      }

      this.drugList = copyList
    })
    this.$bus.on('drugList', ({ val, val2 }) => {
      this.onePreEach = { ...val2, drugs: this.onePreDrugs }
      const drugList = val.map((item, i) => {
        item.drugFlag = new Date().getTime() + i
        return item
      })
      this.open()
      if (val2.exhibition) {
        this.templateType = val2.templateType
        this.prescripTemplateNum = val2.prescripTemplateNum
        this.prescripTemplateName = val2.prescripName
        this.prescripName = val2.prescripName
        this.isShowLead = false
      }
      if (val2.isImport) {
        this.templateType = val2.templateType
        this.prescripTemplateNum = val2.prescripTemplateNum
        this.prescripTemplateName = val2.prescripName
        this.isShowLead = false
        this.isImport = true
      }
      if (!val2.templateType) {
        this.templateType = ''
        this.prescripTemplateNum = ''
        this.prescripTemplateName = ''
      }
      if (val2.exhibition) {
        this.drugList = [].concat(drugList)
      } else {
        this.drugList = this.drugList.concat(drugList)
      }
    })
    this.$bus.on('prescripType', val => {
      console.log('prescripType---------event--on', val)
      if (val === '3' || val === '5') {
        this.form = {
          herbFrequence: '',
          herbPerDoseTimes: '',
          chineseDrugUsage: '',
          times: '2',
          processMethod: '1',
          packageNumber: '',
          // processMode: 'A001',
          processMode: '',
          processSolution: '02',
          doesNumber: ''
        }
      } else if (val === '6') {
        this.form = {
          herbFrequence: '',
          herbPerDoseTimes: '',
          chineseDrugUsage: 'C',
          times: '',
          processMethod: '2',
          packageNumber: '',
          // processMode: 'A001',
          processMode: '',
          processSolution: '',
          doesNumber: ''
        }
      }
      this.prescripType = val
      this.drugList = []
      this.validDays = '3'
      this.pharmacy = '1001'
      this.prescripChannel = '1'
      this.isNew = true
      console.log('open---', this.open)
      this.open()
    })
    this.$bus.on('updatePrescrip', ({ val, val2 }) => {
      this.isUpdate = true
      this.newValue = val

      this.setPrescripClass(val.prescripClass)

      this.templateType = val.templateType
      this.prescripSort = val2 + 1 + ''
      this.prescripType = val.prescripType
      this.prescripChannel = val.prescripChannel

      this.prescripNum = val.prescripNum

      this.templateType = val.templateType
      this.prescripTemplateNum = val.prescripTemplateNum
      this.prescripTemplateName = val.prescripTemplateName
      this.drugList = val.prescripDrugsInfoList.map((item, i) => {
        item.drugFlag = new Date().getTime() + i
        return item
      })

      Object.assign(this.form, {
        herbFrequence: val.herbFrequence,
        herbPerDoseTimes: val.herbPerDoseTimes,

        chineseDrugUsage: val.chineseDrugUsage,
        times: val.times,
        processMethod: val.processMethod,
        packageNumber: val.packageNumber,
        processMode: val.processMode,
        processSolution: val.processSolution,
        doesNumber: val.doesNumber,
        prescripDesc: val.prescripDesc
      })
      this.form.doesNumber = val.doesNumber

      this.validDays = val.validDays
      this.pharmacy = val.warehouseID

      // eslint-disable-next-line vue/no-mutating-props
      // this.recordItem = Object.assign(this.recordItem, {
      //   patientName: val.patientName,
      //   patientSex: val.sex,
      //   symptomName: val.diagnosis,
      //   patientAge: val.age
      // })
      this.$emit('update:recordItem', {
        ...this.recordItem,
        patientName: val.patientName,
        patientSex: val.sex,
        symptomName: val.diagnosis,
        patientAge: val.age
      })
      this.open()
    })
    this.$bus.on('copyPrescrip', ({ val, val2 }) => {
      this.setCopyPrescrip(val, val2)
      // 解决初次进入不渲染
      setTimeout(() => {
        this.setCopyPrescrip(val, val2)
        this.open()
      }, 100)
    })
    this.$bus.on('createNewPre', val2 => {
      this.setPrescripClass('1')
      this.prescripSort = !val2 ? '1' : val2 + 1 + ''
    })
    this.$bus.on('deleteDrug', list => {
      this.drugList = [...list]
      // 提示框展示判定
      this.drugList.length === 0 && this.msZheng === true ? (this.msZheng = false) : ''
    })
    this.$bus.on('cancelAddDrug', val => {
      this.open()
    })

    // const eventChannel = this.getOpenerEventChannel()
    // uni.$on('MKResult', data => {
    //   console.log('MKResultMKResult', data)
    //   this.reasonableMedicationReturn(data)
    // })
    // uni.$on('MKResultBack', () => {
    //   console.log('MKResultBackMKResultBack')
    //   this.reasonableMedicationReturn(1)
    // })
  },
  unmounted() {
    this.$bus.off('isMengPre')
    this.$bus.off('showPrescription')
    this.$bus.off('prescripDetail')
    this.$bus.off('prescripClass')
  },
  onBackPress() {
    console.log('onBackPressonBackPress')
    // uni.$emit('MKResultBack', 1)
  }
}
</script>

<style lang="scss" scoped>
.gridClass ::v-deep .uni-list:after {
  background-color: transparent !important;
}
.prescrip_class ::v-deep .uni-list-item__container {
  padding: 0;
  border-bottom: 0.021333rem solid #ececec;
  font-family: PingFangSC-Regular, PingFang SC !important;
}
.prescrip_class ::v-deep .list-item {
  border-bottom: 0.021333rem solid #ececec;
}
.prescrip_class ::v-deep .uni-list--border:after {
  background-color: transparent !important;
  height: 0 !important;
}
.prescrip_class ::v-deep .uni-list-item {
  border-top: 0.021333rem solid #ececec !important;
  font-family: PingFangSC-Regular, PingFang SC !important;
}
.prescrip_class ::v-deep .uni-list-item__content-title {
  font-family: PingFangSC-Regular, PingFang SC !important;
}
.prescrip_class ::v-deep .uni-list-item__extra-text {
  font-family: PingFangSC-Regular, PingFang SC !important;
}
radio {
  transform: scale(0.7);
}
radio .wx-radio-input {
  border-radius: 50%;
  width: 0.426667rem !important;
  height: 0.426667rem !important;
}
radio .wx-radio-input.wx-radio-input-checked {
  border: none !important;
  background: #0089ff !important;
}
radio .wx-radio-input.wx-radio-input-checked::before {
  border-radius: 50%;
  width: 0.426667rem !important;
  height: 0.426667rem !important;
  line-height: 0.426667rem !important;
  text-align: center;
  font-size: 0.384rem;
  color: #fff;
  background: transparent;
  transform: translate(-50%, -50%) scale(1);
  -webkit-transform: translate(-50%, -50%) scale(1);
}
</style>
<style lang="scss" scoped>
.popup-wrap {
  width: 10.666667rem;
  min-height: 5.546667rem;
  border-radius: 0.341333rem;
  padding: 0.64rem 0.64rem 2.773333rem 0.64rem;
  background-color: #fff;
  font-size: 0.512rem;
  font-family: PingFang SC;
  font-weight: 500;
  color: #444444;
  line-height: 0.810667rem;
  overflow: hidden;
  position: relative;

  .title-wrap {
    width: 100%;
    height: 1.92rem;
    text-align: center;
    line-height: 1.92rem;
    font-size: 0.768rem;
    color: #222222;
    font-weight: 600;
  }

  .umbra {
    position: absolute;
    bottom: 3.84rem;
    left: 0rem;
    width: 100%;
    height: 0.426667rem;
    background-color: rgba(255, 255, 255, 0.5);
    background-image: linear-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255, 1));
  }

  .content-wrap {
    height: auto;
    color: #222222;
    font-size: 0.64rem;
    margin-top: 0.426667rem;
    overflow-y: scroll;
    max-height: 17.066667rem;

    .common {
      word-wrap: break-word;
      font-family: PingFang-SC-Medium, PingFang SC, Menksoft Budun;
    }
  }
  .have-know {
    width: 6.4rem;
    height: 1.706667rem;
    text-align: center;
    line-height: 1.706667rem;
    color: #0089ff;
    border-radius: 0.853333rem;
    border: 0.021333rem solid #0089ff;
    position: absolute;
    left: 2.56rem;
    bottom: 0.768rem;
  }
  .protocol {
    width: 100%;
    height: 1.450667rem;
    display: flex;
    align-items: center;
    .protocol-text {
      font-size: 0.512rem;
      font-family: PingFang SC;
      font-weight: 400;
      color: #888;
    }
  }
}
.gridClass {
  background-color: #fff;
  height: 18.346667rem;
  overflow-y: scroll;
  overflow-x: hidden;
  z-index: 1100;

  .grid_wrap {
    ::v-deep .uni-list-item__extra-text {
      font-family: PingFangSC-Regular, PingFang SC !important;
    }
    .prescrip_class {
      border-bottom: 0.021333rem solid #ececec;
    }
    .card_wrap {
      border-top: 0.021333rem solid #ececec;
      font-family: PingFangSC-Regular, PingFang SC !important;

      .fst_row {
        color: #222;
        font-size: 0.64rem;
        display: flex;
        justify-content: space-between;
        width: 100%;
        padding: 0.682667rem 0.64rem 0 0.682667rem;
        box-sizing: border-box;
        font-family: PingFangSC-Regular, PingFang SC !important;
        .label {
          font-weight: 400;
          font-family: PingFangSC-Regular, PingFang SC !important;
        }
        .text {
          font-family: PingFangSC-Regular, PingFang SC !important;
        }
        text:last-child {
          color: #0089ff;
          font-weight: 400;
        }
      }
      .row {
        color: #888;
        padding-bottom: 0.64rem;
        font-size: 0.64rem;
        font-weight: 400;
        font-family: PingFangSC-Regular, PingFang SC !important;

        .label {
          font-weight: 400;
          font-family: PingFangSC-Regular, PingFang SC !important;
        }
        .text {
          color: #222;
          margin-right: 0.426667rem;
          font-weight: 400;
          font-family: PingFangSC-Regular, PingFang SC !important;
        }
      }
      .special {
        padding-bottom: 0;
      }
    }
    .input_wrap {
      display: flex;
      padding: 0 0.682667rem 0 0.682667rem;
      align-items: center;
      justify-content: space-between;
      height: 2.005333rem;
      font-family: PingFangSC-Regular, PingFang SC !important;
      .input_title,
      .input_row {
        font-family: PingFangSC-Regular, PingFang SC !important;
      }
      .input_row {
        display: flex;
        width: 3.84rem;
        height: 100%;
        align-items: center;
        .input_con {
          text-align: right;
        }
        .unit {
          margin-left: 0.213333rem;
          font-family: PingFangSC-Regular, PingFang SC !important;
        }
      }
    }
    .row_wrap,
    .align {
      width: 100%;
      min-height: 2.218667rem;
      padding: 0.533333rem 0.682667rem;
      position: relative;
      display: flex;
      border-bottom: 0.021333rem solid #ececec;
      box-sizing: border-box;
      font-family: PingFangSC-Regular, PingFang SC !important;
      .add_img {
        width: 0.853333rem;
        height: 0.853333rem;
        position: absolute;
        right: 0.64rem;
      }
      label {
        min-width: 3.84rem;
      }
      .title,
      .r_text {
        font-size: 0.64rem;
        color: #222;
        font-family: PingFangSC-Regular, PingFang SC !important;
      }
      .title,
      .diagnosis_content {
        display: flex;
        flex-flow: row wrap;
        align-content: space-around;
        .diagnose_wrap {
          width: auto;
          font-size: 0.512rem;
          font-weight: 400;
          color: #222222;
          line-height: 0.682667rem;
          height: 0.682667rem;
          background: #eee;
          padding: 0.085333rem 0.256rem;
          margin: 0 0.512rem 0.426667rem 0;
          // margin-right: .512rem;
          .symptom_text {
            font-family: PingFangSC-Regular, PingFang SC !important;
          }
          .meng_text {
            font-family: PingFang-SC-Medium, PingFang SC, Menksoft Budun !important;
          }
        }
      }
      .valid_day {
        width: 2.56rem;
      }
      .diagnosis {
        font-size: 0.64rem;
        font-weight: 400;
        color: #222;
        line-height: 0.853333rem;
        min-width: 2.133333rem !important;
        font-family: PingFangSC-Regular, PingFang SC !important;
      }
      .addDrug {
        color: #0089ff;
        font-size: 0.597333rem;
        position: absolute;
        right: 0.64rem;
      }
    }
    .align {
      align-items: center;
    }
    .lead_wrap {
      height: 3.84rem;
      padding: 0.682667rem;
      box-sizing: border-box;
      .lead_img {
        width: 14.634667rem;
        height: 2.453333rem;
      }
      .lead_margin {
        margin-left: 0.384rem;
      }
    }
  }
  .serviceType {
    height: 0.981333rem;
    border-radius: 0.085333rem;
    text-align: end;
    line-height: 0.981333rem;
    font-size: 0.64rem;
    font-weight: 400;
    color: #222;
    .self {
      font-family: PingFangSC-Regular, PingFang SC !important;
    }
  }
  .patientName {
    font-size: 0.725333rem;
    font-family: PingFang SC;
    font-weight: bold;
    color: #222222;
    .sex,
    .age {
      font-size: 0.64rem;
      font-weight: 400;
      color: #222222;
      line-height: 0.64rem;
      margin-left: 0.298667rem;
      font-family: PingFangSC-Regular, PingFang SC;
    }
    .sex {
      margin-left: 0.512rem;
    }
  }
  .preType {
    width: max-content;
    height: 0.768rem;
    border-radius: 0.085333rem;
    border: 0.021333rem solid #0089ff;
    text-align: center;
    line-height: 0.768rem;
    padding: 0 0.256rem;
    color: #0089ff;
    margin-top: 0.32rem;
    font-size: 0.512rem;
  }
}
.gridClass::-webkit-scrollbar {
  display: none;
}
.estimate_wrap {
  height: 1.877333rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 0.021333rem solid #ececec;
  border-bottom: 0.021333rem solid #ececec;
  padding: 0 0.682667rem;
  .title {
    font-size: 0.597333rem;
    font-weight: 400;
    color: #222222;
    font-family: PingFangSC-Regular, PingFang SC;
  }
  .price,
  .tag {
    font-size: 0.682667rem;
    font-weight: 600;
    color: #ff7555;
  }
  .tag {
    margin-right: 0.213333rem;
  }
}
.bottom {
  display: flex;
  justify-content: space-between;
  height: 4.138667rem;
  padding: 0.384rem 0.682667rem;
  box-sizing: border-box;
  .footer-box,
  .oneperson_style {
    text-align: center;
    width: 6.976rem;
    height: 1.877333rem;
    background: #ffffff;
    border-radius: 0.938667rem;
    border: 0.021333rem solid #0089ff;
    line-height: 1.877333rem;
    font-size: 0.682667rem;
    font-weight: 500;
    .btn {
      color: #0089ff;
    }
  }
  .oneperson_style {
    width: 14.634667rem;
  }
}
</style>
